import styled from 'styled-components';

export const StyledDataStoragePanel = styled.div`
   display: flex;
   flex-direction: column;
   gap: 12px;
   max-width: 550px;
`;

StyledDataStoragePanel.displayName = 'StyledDataStoragePanel';
